/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SubjectStatusEnum {
    Draft = 'Draft',
    PendingDirectorValidation = 'PendingDirectorValidation',
    PendingDeanValidation = 'PendingDeanValidation',
    PendingQaValidation = 'PendingQAValidation',
    Approved = 'Approved',
    All = 'All'
}

export function SubjectStatusEnumFromJSON(json: any): SubjectStatusEnum {
    return SubjectStatusEnumFromJSONTyped(json, false);
}

export function SubjectStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubjectStatusEnum {
    return json as SubjectStatusEnum;
}

export function SubjectStatusEnumToJSON(value?: SubjectStatusEnum | null): any {
    return value as any;
}

